export default __webpack_public_path__ + "static/media/IUSDP_logo.21483dda.png";